export default {
    baseURL: '/',
    headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
    }
}






// WEBPACK FOOTER //
// ./src/config/api.conf.js